<template>
  <div class="mode-switcher">
    <svg
      v-show="active"
      width="58"
      height="32"
      viewBox="0 0 58 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 6C0 2.68629 2.68629 0 6 0H58V32H6C2.68629 32 0 29.3137 0 26V6Z"
        fill="#1D1D1B"
      />
      <rect x="20" y="7" width="18" height="4" fill="#EDEDED" />
      <rect x="20" y="14" width="18" height="4" fill="#EDEDED" />
      <rect x="20" y="21" width="18" height="4" fill="#EDEDED" />
    </svg>

    <svg
      v-show="!active"
      @click="toggleMode()"
      width="58"
      height="32"
      viewBox="0 0 58 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="20" y="7" width="18" height="4" fill="#908F8D" />
      <rect x="20" y="14" width="18" height="4" fill="#908F8D" />
      <rect x="20" y="21" width="18" height="4" fill="#908F8D" />
      <path
        d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H57.5V31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6Z"
        stroke="#908F8D"
      />
    </svg>

    <svg
      @click="toggleMode()"
      v-show="active"
      width="58"
      height="32"
      viewBox="0 0 58 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="20" y="7" width="4" height="4" fill="#908F8D" />
      <rect x="20" y="14" width="4" height="4" fill="#908F8D" />
      <rect x="20" y="21" width="4" height="4" fill="#908F8D" />
      <rect x="27" y="7" width="4" height="4" fill="#908F8D" />
      <rect x="27" y="14" width="4" height="4" fill="#908F8D" />
      <rect x="27" y="21" width="4" height="4" fill="#908F8D" />
      <rect x="34" y="7" width="4" height="4" fill="#908F8D" />
      <rect x="34" y="14" width="4" height="4" fill="#908F8D" />
      <rect x="34" y="21" width="4" height="4" fill="#908F8D" />
      <path
        d="M0.5 0.5H52C55.0376 0.5 57.5 2.96243 57.5 6V26C57.5 29.0376 55.0376 31.5 52 31.5H0.5V0.5Z"
        stroke="#908F8D"
      />
    </svg>

    <svg
      v-show="!active"
      width="58"
      height="32"
      viewBox="0 0 58 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H52C55.3137 0 58 2.68629 58 6V26C58 29.3137 55.3137 32 52 32H0V0Z"
        fill="#1D1D1B"
      />
      <rect x="20" y="7" width="4" height="4" fill="#EDEDED" />
      <rect x="20" y="14" width="4" height="4" fill="#EDEDED" />
      <rect x="20" y="21" width="4" height="4" fill="#EDEDED" />
      <rect x="27" y="7" width="4" height="4" fill="#EDEDED" />
      <rect x="27" y="14" width="4" height="4" fill="#EDEDED" />
      <rect x="27" y="21" width="4" height="4" fill="#EDEDED" />
      <rect x="34" y="7" width="4" height="4" fill="#EDEDED" />
      <rect x="34" y="14" width="4" height="4" fill="#EDEDED" />
      <rect x="34" y="21" width="4" height="4" fill="#EDEDED" />
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: true,
    };
  },
  methods: {
    toggleMode() {
      this.active = !this.active;
    },
  },
};
</script>

<style scoped>
.mode-switcher {
  position: absolute;
  right: 5.5vh;
  top: 5vh;
}
</style>